import * as React from 'react';
import {useState} from 'react';
import {CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import {useTranslation} from "react-i18next";
import PreviewIcon from '@mui/icons-material/Preview';
import {fetchExpenseFile} from "../../api/api";
import {LoadingItem} from "../loading-item/LoadingItem";
import Typography from "@mui/material/Typography";


interface Props {
    context: string,
    id: string,
    fileName: string
}

export default function ExpensePreviewDialog(props: Props) {
    const {t} = useTranslation();
    const {context, id, fileName} = props;
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [blobUrl, setBlobUrl] = useState('');

    const handleClickOpen = async () => {
        setLoading(true);
        const blob = await fetchExpenseFile(props);
        const blobUrl = URL.createObjectURL(blob);
        setBlobUrl(blobUrl);
        setOpen(true);
        setLoading(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            {context == 'icon' ? <IconButton onClick={handleClickOpen} disabled={loading}>
                {loading ? <LoadingItem><CircularProgress/></LoadingItem> : <PreviewIcon/>}
            </IconButton> : <Typography
                variant="body2"
                sx={{
                    color: "primary.main",
                    textDecoration: "underline",
                    cursor: "pointer",
                }}
                onClick={() => handleClickOpen()}
            >
                {fileName}
            </Typography>}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
            >
                <DialogTitle>{t('Expense preview')} {fileName}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                    </DialogContentText>
                    <Box sx={{width: '100%'}}>
                        {!loading ? (
                            <iframe
                                src={blobUrl}
                                width="100%"
                                height="600px"
                                title="PDF Preview"
                                style={{border: 'none'}}
                            />
                        ) : (
                            <CircularProgress/>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};